/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How much a competitor sees of a judged submission, ranked from least to most.
 * @export
 */
export const FeedbackLevel = {
    None: 'none',
    Score: 'score',
    Public: 'public',
    Full: 'full'
} as const;
export type FeedbackLevel = typeof FeedbackLevel[keyof typeof FeedbackLevel];


export function instanceOfFeedbackLevel(value: any): boolean {
    for (const key in FeedbackLevel) {
        if (Object.prototype.hasOwnProperty.call(FeedbackLevel, key)) {
            if (FeedbackLevel[key as keyof typeof FeedbackLevel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FeedbackLevelFromJSON(json: any): FeedbackLevel {
    return FeedbackLevelFromJSONTyped(json, false);
}

export function FeedbackLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedbackLevel {
    return json as FeedbackLevel;
}

export function FeedbackLevelToJSON(value?: FeedbackLevel | null): any {
    return value as any;
}

export function FeedbackLevelToJSONTyped(value: any, ignoreDiscriminator: boolean): FeedbackLevel {
    return value as FeedbackLevel;
}

